import Image from 'next/image';

import { CapitalRequestMatch } from '@scaleup/models';
import {
  useAcceptDeclineCrmMutation,
  useGetCrCapitalProviderQuery,
  useGetCrMatchesQuery,
} from '../../api';
import { useAlert } from '../../hooks';
import { OrgAvatar } from '../../ui';

export const CapitalProviderCard = ({
  capitalRequestMatch,
}: {
  capitalRequestMatch: CapitalRequestMatch;
}) => {
  const setAlert = useAlert();
  const [acceptDeclineCrm, { isLoading: acceptDeclineSrmLoading }] =
    useAcceptDeclineCrmMutation();
  const { refetch: refetchCrMatches } = useGetCrMatchesQuery(
    capitalRequestMatch.requestId
  );
  const { data: capitalProvider, isLoading } = useGetCrCapitalProviderQuery({
    id: capitalRequestMatch.requestId,
    matchId: capitalRequestMatch.matchId,
  });

  const handleAcceptDecline = async (accept: boolean) => {
    await acceptDeclineCrm({
      id: capitalRequestMatch.requestId,
      matchId: capitalRequestMatch.matchId,
      accept,
    });
    await refetchCrMatches();
    if (accept) {
      setAlert({
        title: 'Capital provider accepted',
        message: 'Capital provider accepted successfully',
        severity: 'success',
        show: true,
      });
    } else {
      setAlert({
        title: 'Capital provider decline',
        message: 'Capital provider declined successfully',
        severity: 'success',
        show: true,
      });
    }
  };

  return (
    <div className="flex-1 rounded-[2rem] bg-white flex flex-col justify-between">
      <div className="py-[4rem] px-[2rem] flex flex-col gap-4">
        <OrgAvatar orgId={capitalRequestMatch.orgId} />
        <span className="text-2xl font-bold">
          {capitalRequestMatch.orgName}
        </span>
        <span>{capitalProvider?.capitalProviderData.description}</span>
        <a
          className="text-primary-700 font-bold text-sm flex gap-2 cursor-pointer transition-all hover:scale-[1.01]"
          onClick={() => {}}
        >
          View Detail
          <Image
            src="/icons/arrow-right.svg"
            width={20}
            height={20}
            alt="Icon"
          />
        </a>
      </div>
      <div className="flex gap-2 shadow-top p-8 rounded-b-[32px]">
        <button
          className="border border-primary-600 text-primary-600 font-bold rounded-full px-4 py-3 flex-1"
          onClick={handleAcceptDecline.bind(null, false)}
          disabled={acceptDeclineSrmLoading || isLoading}
        >
          Not the right fit
        </button>
        <button
          className="font-bold bg-gradient-to-r from-[#4AAECA] from-0% to-[#4EB3CF] to-100% text-white rounded-full px-4 py-3 flex-1"
          onClick={handleAcceptDecline.bind(null, true)}
          disabled={acceptDeclineSrmLoading || isLoading}
        >
          &#10004; Accept
        </button>
      </div>
    </div>
  );
};
